import { render } from "./InputText.vue?vue&type=template&id=a401e7e4"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a401e7e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a401e7e4', script)) {
    api.reload('a401e7e4', script)
  }
  
  module.hot.accept("./InputText.vue?vue&type=template&id=a401e7e4", () => {
    api.rerender('a401e7e4', render)
  })

}

script.__file = "src/components/common/field/InputText.vue"

export default script